<script>
   /*************************************************************/
   /* Svelte component for changing SIMCA settings              */
   /*************************************************************/

   // main properties of the whole app
   export let simca;
   export let ncomp;
   export let isAlt = false;
</script>


{#if simca && ncomp > 0}
<table>
   <tr>
      <th></th>
      <th>h</th>
      <th>q</th>
      <th>f</th>
   </tr>
   <tr>
      <td class="label">DoF (Nu)</td>
      <td>{simca.Nh[ncomp - 1]}</td>
      <td>{simca.Nq[ncomp - 1]}</td>
      <td>{simca.Nf[ncomp - 1]}</td>
   </tr>
   <tr>
      <td class="label">Mean (u0)</td>
      <td>{simca.h0[ncomp - 1].toFixed(3)}</td>
      <td>{simca.q0[ncomp - 1].toFixed(simca.q0[ncomp - 1] > 99 ? 0 : 3)}</td>
      <td></td>
   </tr>
   <tr>
      <td class="label">Crit (extreme)</td>
      <td></td>
      <td></td>
      <td>{simca.eCrit[ncomp - 1].toFixed(1)}</td>
   </tr>
   {#if !isAlt}
   <tr>
      <td class="label">Crit (outliers)</td>
      <td></td>
      <td></td>
      <td>{simca.oCrit[ncomp - 1].toFixed(1)}</td>
   </tr>
   {/if}
</table>
{/if}

<style>
   table {
      width: 100%;
      border-collapse: collapse;
   }

   tr {
      width: 100%;
   }

   th {
      border-bottom: 1px solid #a0a0a0;
   }

   th, td {
      text-align: right;
      padding: 0.2em 0.5em 0.2em 0.1em;
      color: #404040;
      margin: 0;
   }

   .label {
      text-align: left;
      padding: 0.1em 0.5em;
   }
</style>